export default api => {
    return {
        namespaced: true,
        state: {
            my_active: null,
        },
        getters: {
            my_active: state => state.my_active,
        },
        mutations: {
            setMyActive(state, events) {
                state.my_active = events
            }
        },
        actions: {

            async loadMyActive({commit}) {
                let events = await api.my_active()
                commit('setMyActive', events)
            },


            async post({dispatch}, fields) {
                const school = await api.store(fields)
                await dispatch('_load')
                return school
            },

            async update({dispatch}, {id, fields}) {
                const school = await api.update(id, fields)
                await dispatch('_load')
                return school
            },

            async destroy({dispatch}, id) {
                await api.destroy(id)
                await dispatch('_load')
            }

        }
    }
}